import { TERMS_SCENE } from "../config/terms-scene.js";

const ORBITAL_WORLD = TERMS_SCENE.environment;

export function legalWorldMarkup({ still = false } = {}) {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const moving = !still && !reduced;
  return `
    <div class="legal-world" data-legal-world data-world-id="${ORBITAL_WORLD.assetId}" data-motion="${moving ? "running" : "static"}" style="--legal-world-position:${ORBITAL_WORLD.desktopObjectPosition};--legal-world-position-mobile:${ORBITAL_WORLD.mobileObjectPosition}" aria-hidden="true">
      <video class="legal-world__film" data-legal-world-film muted playsinline tabindex="-1"
        ${moving ? "autoplay loop" : ""} preload="${moving ? "metadata" : "none"}" poster="${ORBITAL_WORLD.poster}">
        ${moving ? ORBITAL_WORLD.sources.map((source) => `<source src="${source.src}" type="${source.type}">`).join("") : ""}
      </video>
      <div class="legal-world__depth" aria-hidden="true"></div>
      <div class="legal-world__occlusion legal-world__occlusion--left" aria-hidden="true"></div>
      <div class="legal-world__occlusion legal-world__occlusion--right" aria-hidden="true"></div>
    </div>`;
}

export function createLegalWorldController(root, compositor, { still = false } = {}) {
  const world = root.querySelector("[data-legal-world]");
  const film = root.querySelector("[data-legal-world-film]");
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  let manuallyPaused = false;

  function ensureSources() {
    if (film.querySelector("source")) return;
    film.replaceChildren(...ORBITAL_WORLD.sources.map((sourceConfig) => {
      const source = document.createElement("source");
      source.src = sourceConfig.src;
      source.type = sourceConfig.type;
      return source;
    }));
    film.load();
  }

  function sync() {
    const running = !still && !reduced.matches && !manuallyPaused && !document.hidden;
    world.dataset.motion = running ? "running" : still || reduced.matches ? "static" : "paused";
    if (running) {
      ensureSources();
      film.loop = true;
      film.play().catch(() => {});
    } else film.pause();
    compositor.toggle(running);
    return running;
  }

  function onVisibility() {
    sync();
  }

  function onMotionChange() {
    sync();
  }

  document.addEventListener("visibilitychange", onVisibility);
  reduced.addEventListener("change", onMotionChange);
  sync();

  return Object.freeze({
    toggle() {
      manuallyPaused = !manuallyPaused;
      return sync();
    },
    getState() {
      return Object.freeze({
        assetId: ORBITAL_WORLD.assetId,
        motion: world.dataset.motion,
        localOnly: true,
        mutation: false,
      });
    },
    destroy() {
      manuallyPaused = true;
      film.pause();
      document.removeEventListener("visibilitychange", onVisibility);
      reduced.removeEventListener("change", onMotionChange);
      compositor.destroy();
    },
  });
}
